/* eslint-disable no-undef */
$(() => {
  let displayView = 'list';

  const toggleToListView = function () {
    $('div.compact-view').addClass('d-none');
    $('div.list-view').removeClass('d-none');
    $('div.card').removeClass('border-0').addClass('mb-4');
  };

  const toggleToCompactView = function () {
    $('div.compact-view').removeClass('d-none');
    $('div.list-view').addClass('d-none');
    $('div.card').addClass('border-0').removeClass('mb-4');
  };

  const resetSelects = function ($selector) {
    $selector.each(function () {
        $(this)[0].selectedIndex = 0;
      });
  };

  const options = {
    valueNames: [
      { name: 'department', attr: 'data-info' },
      { name: 'last_initial', attr: 'data-info' },
      { name: 'last_name', attr: 'data-info' },
      { name: 'location', attr: 'data-info' },
      { name: 'role', attr: 'data-info' },
      { name: 'academic_unit', attr: 'data-info' },
      { name: 'is_head', attr: 'data-info' },
      { name: 'meta', attr: 'data-info' },
      { name: 'original_sort', attr: 'data-info' },
      'title',
      ],
  };

  const peopleList = new List('people', options);
  const $filterControls = $('#filters').find('select.filter-controls');
  const $searchInput = $('#people-list-search');
  const noItems = $('<div class="alert alert-warning">No Results. Try a different search string or filter options.</div>');

  $searchInput.on('focus', () => {
      $filterControls.val('')
        .removeClass('bg-success text-white');

      resetSelects($filterControls);
      peopleList.search();
      peopleList.sort('original_sort');
    }).on('keyup', function () {
      const val = $(this).val();
      peopleList.search(val, ['meta']);
  });


  $filterControls.on('change', function () {
    const $this = $(this);
    const which = $this.data('controls');
    const searchString = $this.find(':selected').val();
    const $siblings = $this.siblings('select');

    $filterControls.removeClass('bg-success text-white');
    $this.addClass('bg-success text-white');
    resetSelects($siblings);
    $searchInput.val('');

    if (searchString === 'any') {
      peopleList.search();
      peopleList.sort('original_sort');
    } else {
      peopleList.search(searchString, [which]);
      if (which === 'department') {
        $('.department-link').removeClass('btn-info').addClass('btn-dark');
        $(`#${searchString}`).removeClass('btn-dark').addClass('btn-info');
        peopleList.sort('is_head', { order: 'desc' });
      } else if (which === 'last_initial') {
        peopleList.sort('last_name', { order: 'asc' });
      }
    }

    if (displayView === 'list') {
      toggleToListView();
    } else {
      toggleToCompactView();
    }

    //ga('send', 'event', 'Filter - Staff Directory', which, searchString);
  });

  peopleList.on('updated', (list) => {
    if (list.matchingItems.length === 0) {
      $(list.list).append(noItems);
    } else {
      noItems.detach();
    }
  });

  $('#toggle-list-view').on('click', () => {
      if (displayView === 'list') {
        displayView = 'compact';
        toggleToCompactView();
      } else {
        displayView = 'list';
        toggleToListView();
      }
  });
});
